import corporateTrackingMap from '@us/app/config/corporate_tracking_map'

const updateInitialPathAndQueryWithTrackingData = () => {
  // check if query has a corporate
  //     if it has a dot update the corporate and add tracking param to query
  //     else if it is in tracking map update corp and add tracking params to query
  // else if there is a first path
  //     if it has a dot update the first path and add tracking param to query
  //         map '/[corp_key].[tracker]' to '/[corp_key]?utm_campaign=[tracker]'
  //     else if it is in tracking map update first path and add tracking params to query

  const query = new URLSearchParams(window.location.search)
  let path = window.location.pathname.split('/')

  if (query.get('corporate') != null) {
    const corporateFromQuery = `${query.get('corporate')}`.toLowerCase()
    const corporateTrackingRecord = corporateTrackingMap[corporateFromQuery]
    if (corporateFromQuery.includes('.')) {
      query.set('utm_campaign', corporateFromQuery.split('.')[1])
      // if the path is empty push the corporate into the path
      if (!path[1]) {
        path[1] = corporateFromQuery.split('.')[0]
        query.delete('corporate')
      } else {
        query.set('corporate', corporateFromQuery.split('.')[0])
      }
    } else if (corporateTrackingRecord) {
      Object.entries(corporateTrackingRecord.query).forEach(([key, value]) => {
        query.set(key, value.toString())
      })
      if (corporateTrackingRecord.corporate) {
        // if the path is empty push the corporate into the path
        if (!path[1]) {
          path[1] = corporateTrackingRecord.corporate
          query.delete('corporate')
        } else {
          query.set('corporate', corporateTrackingRecord.corporate)
        }
      } else {
        query.delete('corporate')
      }
    }
  } else if (path[1]) {
    const corporateFromPath = path[1].toLowerCase()
    const corporateTrackingRecord = corporateTrackingMap[corporateFromPath]
    if (corporateFromPath.includes('.')) {
      path[1] = corporateFromPath.split('.')[0]
      query.set('utm_campaign', corporateFromPath.split('.')[1])
    } else if (corporateTrackingRecord) {
      Object.entries(corporateTrackingRecord.query).forEach(([key, value]) => {
        query.set(key, value.toString())
      })
      if (corporateTrackingRecord.corporate) {
        path[1] = corporateTrackingRecord.corporate
      } else {
        path = ['', '']
      }
    }
  }

  const url = `${path.join('/')}?${query.toString()}${window.location.hash}`
  window.history.replaceState({}, '', url)
}

export default updateInitialPathAndQueryWithTrackingData
